import { render, staticRenderFns } from "./PriceInterface.vue?vue&type=template&id=2f0f07f1&scoped=true"
import script from "./PriceInterface.vue?vue&type=script&lang=js"
export * from "./PriceInterface.vue?vue&type=script&lang=js"
import style0 from "./PriceInterface.vue?vue&type=style&index=0&id=2f0f07f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f07f1",
  null
  
)

export default component.exports